import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import ProjectForcastFormContainer from './ProjectForcastFormContainer';

const ChanceAddForecastContainer = () => {
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState({
    name: '프로젝트 포캐스팅 추가',
  });
  const handleGoBack = () => {
    navigate('/chancemng');
  };
  return (
    <>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="포케스팅 관리/포케스팅 등록/프로젝트 포케스팅 추가"
        menuLink="/chancemng"
        icon="chance"
        titleData={titleData}
      />
      <ProjectForcastFormContainer />
    </>
  );
};

export default ChanceAddForecastContainer;
